import { Button, EasyModal, Select } from '@ui';
import Icon from '@app/components/ui/icons';
import useTranslation from '@app/hooks/use-translation';
import React, { Dispatch, FC, SetStateAction, useMemo, useState } from 'react';
import { MetricTemplatesGroupType } from '@app/interfaces/slices-types/metric-templates.type';

type PropsType = {
  show: boolean;
  name: string;
  applyBtn: (templateId: string) => void;
  metricTemplates: MetricTemplatesGroupType[];
  onClose: Dispatch<SetStateAction<boolean>>;
};

export const AddToTemplateModal: FC<PropsType> = ({
  show,
  onClose,
  applyBtn,
  name,
  metricTemplates,
}) => {
  const { t } = useTranslation('pages.metricTemplates');
  const [selectedTemplate, setSelectedTemplate] = useState(
    metricTemplates?.[0]?.metric_templates_group_id,
  );
  const templatesOptions = useMemo(
    () =>
      metricTemplates.map((template) => ({
        value: template.metric_templates_group_id,
        title: template.name,
      })),
    [metricTemplates],
  );
  function onChangeTemplate(id: string | number) {
    setSelectedTemplate(String(id));
  }
  if (!show) return null;
  return (
    <EasyModal variant="small" withoutFooter show={show} onClose={() => onClose(false)}>
      <div className="flex items-center justify-center gap-[15px] flex-col">
        <div className="p-[16px] rounded-full bg-action/10 relative overflow-hidden flex items-center justify-center">
          <Icon size={22} className="text-action" name={'HelpCircleIcon'} />
        </div>
        <h2 className="text-0color text-[24px] font-[700]">{t('warning')}</h2>
        <span className="text-0color text-[17px] font-[500] text-center">
          {t('add_template')} {name}
        </span>
        <div className="flex gap-3 items-center w-full">
          <span className="whitespace-nowrap">{t('template_group_description')}</span>
          <Select
            dropHeight={140}
            withSearch
            options={templatesOptions}
            defaultValue={selectedTemplate}
            onChange={onChangeTemplate}
          />
        </div>
        <div className=" w-full pb-[30px] pt-[100px] flex items-center px-[70px]">
          <Button onClick={() => applyBtn(selectedTemplate)} className="w-full" label={t('add')} />
          <Button
            className="w-full"
            onClick={() => onClose(false)}
            fill="linked"
            label={t('cancel')}
          />
        </div>
      </div>
    </EasyModal>
  );
};
